import { Component, Input } from '@angular/core';

@Component({
	selector: 'sn-quill-view',
	template: require('./sn-quill-view.html')
})
export class SnQuillViewComponent {
	@Input() content: string;

	constructor() {}

	// We need to ensure that each and every link that will be clicked, have to be opened in new tab
	// The main reason for this is old client portal that gets loaded during redirection in the same tab.
	openUrlInNewTab(event): void {
		const el = event.target;
		if (el.tagName === 'A' && el.target !== '_blank') {
			event.preventDefault();
			window.open(el.href);
		}
	}
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/string-replace-webpack-plugin/loader.js?id=nfw9yna8xro!./shared/components/common/sn-quill-view/sn-quill-view.ts